import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { Persona } from 'src/app/models/personas.interface';

export const PersonaFetch = createAction('[Persona] Fetch', props<{ includeHidden: boolean }>());
export const PersonaFetched = createAction('[Persona] Fetched', props<{ personas: Persona[] }>());
export const PersonaError = createAction('[Persona] Error');

export const initialState: CommonApiState<Persona[]> = {
  data: [],
  currentPedingApis: 0,
  isError: false
};

export const personaFeature = createFeature({
  name: 'persona',
  reducer: createReducer(
    initialState,
    on(PersonaFetch, state => ({
      ...state,
      currentPedingApis: state.currentPedingApis + 1
    })),
    on(PersonaFetched, (state, result) => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: result.personas
      };
    }),
    on(PersonaError, state => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: true
      };
    })
  ),
  extraSelectors: ({ selectPersonaState }) => {
    const personaIsLoading = createSelector(selectPersonaState, personaState => personaState.currentPedingApis > 0);

    //Don't let 2 or more action start another request
    const personaHasPendingRequest = createSelector(
      selectPersonaState,
      personaState => personaState.currentPedingApis >= 2
    );

    return { personaIsLoading, personaHasPendingRequest };
  }
});
